import * as React from 'react';
import clsx from 'clsx';
import waveElementChat from '@/assets/images/webp/wave_element_mock.webp';
import marcusImage from '@/assets/images/echo/marcus_echo.webp';
import elipseImage from '@/assets/images/elements/elipse.webp';

interface MockChatHeaderProps {
  name?: string;
  category?: string;
  avatarSrc?: string;
  className?: string;
}

export const MockChatHeader: React.FC<MockChatHeaderProps> = ({
  name = 'Marcus Aurelius',
  category = 'Philosophy • Stoicism',
  avatarSrc = marcusImage,
  className,
}) => (
  <header
    className={clsx('relative z-20 flex w-full flex-col items-center justify-end pt-4', className)}
  >
    {/* 1. Static Background Wave (Behind Avatar) */}
    <div
      className='absolute inset-0 z-0 flex items-center justify-center overflow-hidden opacity-40'
      style={{ maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)' }}
    >
      <img
        src={waveElementChat}
        alt=''
        className='mt-20 w-[420px] object-cover'
        style={{ transform: 'translateY(-10%)' }}
      />
    </div>

    {/* 2. Avatar Area */}
    <div className='relative z-10 mb-0 flex h-[200px] w-full justify-center'>
      <img
        src={elipseImage}
        alt=''
        className='absolute -top-24 left-1/2 w-[450px] max-w-none -translate-x-1/2 object-contain opacity-100'
        style={{ maskImage: 'linear-gradient(to bottom, black 50%, transparent 75%)' }}
      />

      {/* Avatar Image Wrapper - clips image at header bottom */}
      <div className='absolute -top-4 left-1/2 h-[215px] w-[230px] -translate-x-1/2 overflow-hidden'>
        <img
          src={avatarSrc}
          alt={name}
          className='size-full object-cover object-top'
          style={{ maskImage: 'linear-gradient(to bottom, black 85%, transparent 100%)' }}
        />
      </div>
    </div>

    {/* 3. The Void/Info Overlay */}
    <div
      className='pointer-events-none absolute bottom-[-10px] left-0 z-30 flex w-full flex-col items-center justify-center'
      style={{
        height: '80px',
        transform: 'translateY(50%)',
      }}
    >
      {/* The Gradient Background */}
      <div
        className='absolute inset-0 size-full'
        style={{
          background: 'linear-gradient(180deg, transparent 0%, #2C204C 50%, transparent 100%)',
        }}
      />

      {/* Text Info */}
      <div className='relative z-10 flex flex-col items-center pb-2'>
        <h2 className='font-proxima text-[15px] font-bold leading-tight tracking-normal text-white'>
          {name}
        </h2>

        <div className='mt-1 flex items-center gap-2'>
          <span className='font-proxima text-[11px] font-bold uppercase leading-tight tracking-normal text-white'>
            D.ECHO
          </span>

          <div className='size-[6px] rounded-full bg-accent-200' />

          <span className='font-sans text-[11px] font-normal leading-tight text-white/90'>
            {category}
          </span>
        </div>
      </div>
    </div>
  </header>
);
